import { GET_PARTNERS_LIST } from "./admin.actionsTypes";

const initialState = [];

export default function partnersList(state = initialState, action) {
    switch (action.type) {
        case GET_PARTNERS_LIST:
            const allPartners = action.allPartners || [];

            if (!Array.isArray(allPartners)) {
                return state;
            }
            return [{
                role: 10,
                users: allPartners
            }];
        default:
            return state;
    }
}
